import request from '@/utils/server'
//根据功能间获取设备列表
export function getDeviceList(query) {
    return request({
      url: '/device/getDeviceList',
      method: 'get',
      params: query
    })
  }
  // 根据功能间获取数据

  export function getAllFeeList(query) {
    return request({
      url: '/cost/getAllFeeListByRoom',
      method: 'get',
      params: query
    })
  }